import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import AuthShell from "@/components/auth/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  if (!token) {
    return (
      <AuthShell title="Invalid link" subtitle="This reset link is missing or invalid."
        footer={<Link to="/forgot-password" className="font-semibold text-primary">Request a new link</Link>}>
        <p className="text-sm text-muted-foreground">Please request a new password reset link.</p>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Set a new password" subtitle="Choose a strong password for your account."
      footer={<Link to="/login" className="font-semibold text-primary">Back to sign in</Link>}>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div>
          <Label htmlFor="rp-pass">New password</Label>
          <Input id="rp-pass" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="reset-password" />
        </div>
        <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="reset-submit">
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Update password
        </Button>
      </form>
    </AuthShell>
  );
}
